import { render, staticRenderFns } from "./DidSettings.vue?vue&type=template&id=c5f5f39a&scoped=true&"
import script from "./DidSettings.vue?vue&type=script&lang=js&"
export * from "./DidSettings.vue?vue&type=script&lang=js&"
import style0 from "./DidSettings.vue?vue&type=style&index=0&id=c5f5f39a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f5f39a",
  null
  
)

export default component.exports